import React, { useMemo } from 'react';
import useLoadGsiScript from './hooks/useLoadGsiScript';
import { GoogleOAuthContext } from './context';

export default function GoogleOAuthProvider({
    clientId,
    nonce,  
    onScriptLoadSuccess,
    onScriptLoadError,
    children,
}) {
    const scriptLoadedSuccessfully = useLoadGsiScript({
        nonce,
        onScriptLoadSuccess,
        onScriptLoadError,
    });

    const contextValue = useMemo(() => ({
        clientId,
        scriptLoadedSuccessfully,
    }), [clientId, scriptLoadedSuccessfully]);

    return (
        <GoogleOAuthContext.Provider value={contextValue}>
            {children}
        </GoogleOAuthContext.Provider>
    );
}


